<template>
    <header>
        <div class="right">
            <div class="logout">
                <el-dropdown trigger="click">
                    <span class="el-dropdown-link" v-if="$store.state.username">
                        <i class="fas fa-user-shield"></i>
                        {{ $store.state.username }}
                        <i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item @click.native="loginOut">登出</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
    </header>
</template>
<script>
export default {
    data() {
        return {}
    },
    methods: {
        loginOut() {
            localStorage.removeItem('uq_token')
            this.$router.push({ path: '/login' })
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
header {
    width: 100%;
    background: $color-white;
    height: 60px;
    border-bottom: 1px solid $color-border;
}
.right {
    position: absolute;
    right: 20px;
    top: 20px;
    cursor: pointer;
    font-family: $font-3;
    letter-spacing: 1px;
    display: flex;
}
.lang {
    margin-right: 10px;
}
.fas {
    margin-right: 5px;
}
</style>
